import type { Lead } from '../../../shared/types';

export const EMPTY_LOCATION = {
  lat: null, lng: null, coordinate_source: null, coordinate_at: null,
  address_city: null, address_postal_code: null, location_status: 'unresolved',
  location_attempted_at: null, location_version: 0,
} as const;

/** Read/snapshot boundary, not an IDB schema upgrade: old snapshots need the same defaults. */
export const normalizeLead = (lead: Lead): Lead => ({
  ...lead,
  ...Object.fromEntries(Object.entries(EMPTY_LOCATION).map(([key, value]) =>
    [key, lead[key as keyof Lead] ?? value])),
});

/** Only the rep's own archived placement can be re-created as manual. */
export const restoreManualPair = (lead: Lead): { lat?: number; lng?: number } =>
  lead.coordinate_source === 'manual' && typeof lead.lat === 'number' && typeof lead.lng === 'number'
    && Number.isFinite(lead.lat) && Number.isFinite(lead.lng)
    ? { lat: lead.lat, lng: lead.lng } : {};

export const invalidateLocation = (lead: Lead, patch: Partial<Lead>): Lead => {
  const current = normalizeLead(lead);
  const changed = (['address', 'address_city', 'address_postal_code', 'place_id'] as const)
    .some((k) => Object.hasOwn(patch, k) && patch[k] !== current[k]);
  return changed ? {
    ...current, lat: null, lng: null, coordinate_source: null, coordinate_at: null,
    location_attempted_at: null, location_status: 'unresolved', location_version: current.location_version + 1,
  } : current;
};
